var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-signal",attrs:{"aria-hidden":"true"}}),_c('div',{class:'signal signal-' + _vm.strength},[_c('i',{staticClass:"fa fa-signal text-success",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }